import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/settings/printerBlock/printerBlock.template.html';
import Model from '../../models/settings/settings.model.ts';

import i18n  from "l10n";

import PrinterBlockRow from './printerBlock.row.view.ts';

export default Backbone.View.extend({
    tagName: 'div',
    className: 'card-body card-block',
    model: null,
	template: Handlebars.compile(Template),
    initialize: function (options) {
        var self = this;
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateData = this.template();

		this.$el.html( templateData );

        return this;
	},
	events: {

	},
	loadData: function() {
	    var self = this;

        return $.ajaxDefaultQ({
            url: "rest/api/admin/settings/printer?extra=queue",
            type: 'GET',
            contentType: 'application/json',
            data: {}

        }).done(function (response) {

            var views = {};

            $.each(response.data, function(index, modelValue) {

                var rowView = new PrinterBlockRow({
                    "model": modelValue.settings,
                    "queue": modelValue.queue
                });

                var tempRowView = views[modelValue.queue.id];

                if(tempRowView) { // has Already loaded data for that queue
                    tempRowView.$el.after( rowView.render().el );

                }
                else { // hasn't loaded data for that queue, so append a header before
                    views[modelValue.queue.id] = rowView;
                    self.$el.find("#printerSettings").append( rowView.render().el );

                    var queueName = i18n.lng() == "el" ? modelValue.queue.name : modelValue.queue.englishName;
                    rowView.$el.before('<div>' + i18n.t("pageHeader.queue") + ':&nbsp;<span style="font-style: italic; text-decoration: underline;">' + queueName +'</span></div>');
                }

            });


        }).fail(function (response) {
            console.error("response: ", response);

            $.notify(i18n.t('settings.errorOccurred'), { position:"top center", className: "error" });

        });
	}
});


